import { capitalCase } from "@/lib/utils";

export function UserName({ name }: { name: string }) {
  return (
    <span className="pt-2 xl:pt-0 font-semibold text-secondary xl:text-input text-xs xl:text-base">
      Olá, {capitalCase(name !== "" ? name : "Visitante")}!
    </span>
  );
}
